import type { EchoflicksSessionRemake } from "../types";

/** Keep bucket/key pairs together and never fall back to the original Echo. */
export function remakeVideoSource(remake: EchoflicksSessionRemake) {
  if (remake.final_video_storage_bucket && remake.final_video_storage_path) {
    return {
      storage_bucket: remake.final_video_storage_bucket,
      storage_path: remake.final_video_storage_path,
      storage_is_public: false,
    };
  }
  if (remake.preview_bucket && remake.preview_key) {
    return {
      storage_bucket: remake.preview_bucket,
      storage_path: remake.preview_key,
      storage_is_public: false,
    };
  }
  return null;
}

export function remakeWatchPath(
  sessionId: string | number,
  remakeId: string | number,
) {
  return `/echoflicks_echoes/${encodeURIComponent(sessionId)}/show?${new URLSearchParams({ remake: String(remakeId) })}`;
}
